import * as React from "react";
import Modal from "../../../../ui/modal/Modal";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Checkbox from "../../../../../hiberUiKit/src/atoms/Checkbox/Checkbox";

interface ComponentProps {
	/**
	 * If true, additional checkbox check is required to proceed.
	 */
	hasConfirmationCheckbox?: boolean;
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
}

interface State {
	/**
	 * If true, confirmation is checked and submit button is enabled.
	 */
	changeConfirmed: boolean;
}

type Props = ComponentProps;

export default class ConfirmChangePartnerBrandModal extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {changeConfirmed: !props.hasConfirmationCheckbox};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Confirm"} autoWidth={true}>
				<div style={{width: "500px"}}>
					<p>Are you sure you want to change partner brand?</p>
					{this.props.hasConfirmationCheckbox &&
					<div style={{margin: "20px 0"}}>
						<Checkbox checked={this.state.changeConfirmed}
								  label={"I confirm this is the correct Partner Brand for this User"}
								  onChange={() => this.setState({changeConfirmed: !this.state.changeConfirmed})}/>
					</div>}
					<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
					<div className={"pull-right"}>
						<ButtonPrimary label={"Proceed"} disabled={!this.state.changeConfirmed} onClick={this.props.onConfirm}/>
					</div>
				</div>
			</Modal>
		)
	}
}